<template>
	<i class="icon icon-desapacho_aeronaves"></i>
</template>

<script>
export default {}
</script>
